module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAUhJREFUOBGtlEtKA0EQhmcEBXUnimDWWesFsjG5Qdy5cq+nCF4iW10oeANBRkHPMEu9gJv4AAUn369VpqftTAxa8FGP/ruo7kknyxJWVVUXhlDCyFCsWjexpV5C1IYCZpk07fpuy1jowOOsDsG6tJ1aMwqaZJ4m3k97JpOR/OY4vjn2habKqfbwl0oCeye+gLegpnAJ+uaVu/UyGulLxHbsitgjHMRi8qEa6bOG9kCyAluJJmvUl+EeQisXELeiDXd5nr9Q20d55GvEh8QHrL3ib71uvqWJ9IML7YNkD3R/Z6Af5y6cg2p9kCa0UepoEjzDDqzClaF4G54gtlKNUpctoe5hAzaNdavhftjnZWv0aXbDwqJxPU1E/ev9ERQNolPWThrWi++LR/Q/T0Qdafb3R+uj2WRNx/QTSjN5rN4g9oj0Aeb6YxsDWwt8IuYlkD8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/center/menu/vip1.png
// module id = wMYB
// module chunks = 26